export const makePolicySummaryRows = (layers) =>
  (layers ?? []).map((layer, index) => ({
    key: layer?.id ?? index,
    layerNumber: index + 1,
    name: layer?.shortName ?? null,
    status: layer?.status ?? null,
    reference: layer?.reference ?? null,
  }));

export const hasLayers = (layers) =>
  (layers ?? []).some((layer) => layer?.limit != null);
